"use client";

import { useEffect } from "react";

/**
 * Fallback for Chrome iOS: if overflow-x:clip on #app-wrap doesn't
 * prevent the layout viewport from expanding, this ResizeObserver
 * forces the wrapper's max-width to the visual viewport width.
 */
export function ViewportClamp() {
  useEffect(() => {
    const el = document.getElementById("app-wrap");
    if (!el) return;

    function clamp() {
      el!.style.maxWidth = `${window.innerWidth}px`;
    }

    // Only activate if the page is actually wider than the viewport
    if (document.documentElement.scrollWidth > window.innerWidth) {
      clamp();
    }

    const ro = new ResizeObserver(() => {
      if (document.documentElement.scrollWidth > window.innerWidth) {
        clamp();
      } else {
        el!.style.maxWidth = "";
      }
    });
    ro.observe(document.documentElement);

    window.addEventListener("resize", clamp);
    return () => {
      ro.disconnect();
      window.removeEventListener("resize", clamp);
    };
  }, []);

  return null;
}
